export default {
  DOUGLAS_WELCOME: 'https://douglas.de/',
  DOUGLAS_PROFILER: 'https://www.douglas.de/de/account',
  DOUGLAS_WISHLIST: 'https://www.douglas.de/de/wishlist',
  DOUGLAS_CART: 'https://www.douglas.de/de/cart',
}
